import { render } from "./AppScirtResults.vue?vue&type=template&id=6b6704ab&scoped=true&ts=true"
import script from "./AppScirtResults.vue?vue&type=script&lang=ts"
export * from "./AppScirtResults.vue?vue&type=script&lang=ts"

import "./AppScirtResults.vue?vue&type=style&index=0&id=6b6704ab&scoped=true&lang=css"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b6704ab"]])

export default __exports__